import { jourDeLaSemaine } from './calendrier'

// Jours civils (AAAA-MM-JJ, Europe/Paris) : affichage en français.

export const MOIS = [
  'janvier',
  'février',
  'mars',
  'avril',
  'mai',
  'juin',
  'juillet',
  'août',
  'septembre',
  'octobre',
  'novembre',
  'décembre',
] as const

export const JOURS = [
  'dimanche',
  'lundi',
  'mardi',
  'mercredi',
  'jeudi',
  'vendredi',
  'samedi',
] as const

/** « 2027-05-18 » devient « 18/05/2027 ». */
export function formaterJour(jour: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(jour)
  if (!m) throw new RangeError(`Jour invalide : ${jour}`)
  return `${m[3]}/${m[2]}/${m[1]}`
}

/** « 2026-11-03 » devient « mardi 3 novembre 2026 ». */
export function formaterJourLong(jour: string): string {
  formaterJour(jour)
  const [annee, mois, j] = jour.split('-').map(Number)
  return `${JOURS[jourDeLaSemaine(jour)]} ${j === 1 ? '1er' : j} ${MOIS[mois! - 1]} ${annee}`
}
